export const environment = {
    production: false,
    name:"test",
    url: "https://typasstest.tycg.gov.tw",
    trafficSize: 500, //[交通運輸] 所在位置顯示運輸工具的範圍(公尺)
    trainSize: 500,  //[旅運規劃] 終點站顯示附近景點範圍 (公尺)
    googleAPIUsed: 10000000, //[旅運規劃] google API 為計費制，轉運里程若有一定距離，使用google API (公尺)
    hereAPIUsed: true
  };